import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { compose } from 'recompose';
import { querySelector } from '../../../utils';
import omitProps from '../../../utils/omitProps';

export const GetPerDiemRequestFragment = gql`
  fragment PerDiemRequestDetails on PerDiem {
    id
    created_at {
      iso8601
      display
    }
    requested_by {
      id
      fullname          
    }
    per_diem_date {
      iso8601
      display
    }
    state
    user {
      id
      fullname
      default_district {
        id
        name
      }
    }
    notes
    status {
      debt_collected
      payment_mechanism
      payment_successful
      payment_error
      retryable
      reversible
      payment_date {
        iso8601
        display
      }
    }
    per_diem_request {
      ticket_number {             
        id
        number
        ticket {
          id
          state
          district {
              id
              name
            }
          department {
            id
            name
          }
          job {
            id
          }
        }
      }
    }
  }
`;

export const GetAllPerDiemsApiQuery = gql`
  query GetAllPerDiemsApi(
  $perDiemState: PerDiemStateTypes,
  $requestedAt: String,
  $requestedForDate: String,
  $paymentDate: String,
  $districtId: Int,
  $departmentId: Int,
  $userId: Int,
  $first: Int,
  $last: Int,
  $nextCursor: String,
  $prevCursor: String,
  $sorted: [PerDiemSortOptions],
  $ticketJobNumber: String) {
    per_diems(
      state: $perDiemState, 
      requested_date: $requestedAt,
      requested_for_date: $requestedForDate,
      payment_date: $paymentDate,
      district_id: $districtId,
      department_id: $departmentId,
      user_id: $userId,
      first: $first,
      last: $last,
      after: $nextCursor,
      before: $prevCursor,
      sorted: $sorted,
      ticket_job_number: $ticketJobNumber) {
      count
      pages
      current_page
      pageInfo {
        startCursor
        hasPreviousPage
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...PerDiemRequestDetails
        }
      }
    }
  }
  ${GetPerDiemRequestFragment}
`;


const marshallData = ({ data, ownProps }) => {
  const allPerDiems = querySelector(data, '$.per_diems.edges[*].node', []);
  const [pageInfo] = querySelector(data, '$.per_diems.pageInfo', []);
  const [rowCount] = querySelector(data, '$.per_diems.count', []);
  const [currentPage] = querySelector(data, '$.per_diems.current_page', []);
  const [pages] = querySelector(data, '$.per_diems.pages', []);

  const { loading } = data;
  return {
    ...ownProps,
    data,
    allPerDiems,
    pageInfo,
    rowCount,
    currentPage,
    loading,
    pages,
  };
};

const queryGetAllPerDiemsData = graphql(GetAllPerDiemsApiQuery, {
  props: marshallData,
  options: { fetchPolicy: 'network-only' },
});


/* NOTE: don't use queryMetaHandler for react tables. The table won't see the loading flag
* and the table will flash while re-rendering */
export const queryGetAllPerDiemsGQL = compose(
  queryGetAllPerDiemsData,
  omitProps(['data']),
);

/* NOTE: getting approved on per diem date data in a different query because
 it can't be shown in historical table due to multiple API calls. */
export const GetAllandApprovedPerDiemsQuery = gql`
  query GetAllandApprovedPerDiemsQuery($perDiemState: PerDiemStateTypes, $districtId: Int, $userId: Int, $ticketJobNumber: String) {
    all_per_diems(state: $perDiemState, district_id: $districtId, user_id: $userId, ticket_job_number: $ticketJobNumber) {
      edges {
        node {
         approved_per_diems {
          id
          per_diem_date {
            display
          }
        }
          ...PerDiemRequestDetails
        }
      }
    }
  }
  ${GetPerDiemRequestFragment}
`;

const marshallPendingPerDiemData = ({ data, ownProps }) => {
  const allPerDiems = querySelector(data, '$.all_per_diems.edges[*].node', []);
  return {
    ...ownProps,
    data,
    allPerDiems,
  };
};


const queryGetAllAndApprovedPerDiemsData = graphql(GetAllandApprovedPerDiemsQuery, {
  props: marshallPendingPerDiemData,
  options: { fetchPolicy: 'network-only' },
});

export const queryGetAllAndApprovedPerDiemsGQL = compose(
  queryGetAllAndApprovedPerDiemsData,
  omitProps(['data']),
);
